import React, { useState, useEffect, useRef } from "react";
import CardLayout from "../../components/utils/CardLayout";
import SearchBar from "../../components/utils/SearchBar";
import SideButtons from "../../components/utils/SideButtons";
import Table from "../../components/utils/Table";
import Popconfirm from "../../components/utils/Popover";
import DeleteBin5Fill from "remixicon-react/DeleteBin5FillIcon";
import { Link } from "react-router-dom";
import CheckboxCircleFill from "remixicon-react/CheckboxCircleFillIcon";
import Modal from "../../components/utils/Model";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/utils/Alert";
import AnnouncementActions from "../../redux/Announcement/actions";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import moment from "moment-timezone"; 
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import EyeLineIcon from "remixicon-react/EyeLineIcon";
dayjs.extend(utc);
dayjs.extend(timezone);
const LONG_TIME_FORMAT = process.env.REACT_APP_LONG_TIME_FORMAT || "MM/DD/YYYY, HH:mm:ss";
const DISPLAY_TIMEZONE = process.env.REACT_APP_DISPLAY_TIMEZONE || "US/Eastern";
const PICKER_FORMAT = "MM/DD/YYYY hh:mm A";
const {
  getAnnouncement,
  addAnnouncement,
  deleteAnnouncement,
  resetAnnouncement,
  prepareAnnouncementForm,
} = AnnouncementActions;

const datePickerSlotProps = {
  textField: {
    fullWidth: true,
    size: "small",
    placeholder: "Select date & time",
    sx: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
        backgroundColor: "#fafafa",
        height: "44px",
        transition: "all 0.2s ease-in-out",
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#880303",
        },
        "&.Mui-focused": {
          backgroundColor: "#fff",
          boxShadow: "0 0 0 3px rgba(136, 3, 3, 0.12)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#880303",
          borderWidth: "1.5px",
        },
      },
      "& .MuiInputBase-input": {
        padding: "10px 12px",
        fontSize: "14px",
        color: "#333",
      },
      "& .MuiSvgIcon-root": {
        color: "#880303",
      },
    },
  },
  popper: {
    sx: {
      "& .MuiPaper-root": {
        borderRadius: "16px",
        boxShadow: "0 12px 34px rgba(0,0,0,0.16)",
        border: "1px solid #f0f0f0",
        overflow: "hidden",
        maxHeight: "min(560px, calc(100vh - 32px))",
        display: "flex",
        flexDirection: "column",
      },

      "& .MuiPickersLayout-root": {
        display: "flex",
        flexDirection: "column",
        maxHeight: "100%",
        overflow: "hidden",
      },
      "& .MuiPickersLayout-contentWrapper": {
        overflowY: "auto",
        flex: "1 1 auto",
      },
      "& .MuiPickersLayout-contentWrapper::-webkit-scrollbar": {
        width: "6px",
      },
      "& .MuiPickersLayout-contentWrapper::-webkit-scrollbar-thumb": {
        backgroundColor: "#ddd",
        borderRadius: "3px",
      },
      "& .MuiPickersLayout-actionBar": {
        flexShrink: 0,
      },

      "& .MuiPickersCalendarHeader-root": {
        paddingLeft: "16px",
        paddingRight: "10px",
        marginTop: "12px",
      },
      "& .MuiPickersCalendarHeader-label": {
        fontWeight: 600,
        fontSize: "15px",
        color: "#222",
      },
      "& .MuiPickersArrowSwitcher-button": {
        color: "#880303",
        "&:hover": { backgroundColor: "rgba(136,3,3,0.08)" },
      },
      "& .MuiPickersArrowSwitcher-button.Mui-disabled": {
        color: "#ccc",
      },
      "& .MuiPickersFadeTransitionGroup-root .MuiSvgIcon-root": {
        color: "#880303",
      },

      "& .MuiDayCalendar-weekDayLabel": {
        color: "#9a9a9a",
        fontWeight: 600,
        fontSize: "12px",
        width: "38px",
        height: "38px",
      },

      "& .MuiPickersDay-root": {
        fontSize: "13px",
        fontWeight: 500,
        width: "38px",
        height: "38px",
        borderRadius: "10px",
        margin: "0 1px",
        color: "#333",
      },
      "& .MuiPickersDay-root:hover": {
        backgroundColor: "rgba(136,3,3,0.08)",
      },
      "& .MuiPickersDay-root.Mui-selected": {
        backgroundColor: "#880303 !important",
        color: "#fff",
        fontWeight: 700,
      },
      "& .MuiPickersDay-root.Mui-selected:hover": {
        backgroundColor: "#6e0202 !important",
      },
      "& .MuiPickersDay-root.Mui-disabled": {
        color: "#d5d5d5",
      },
      "& .MuiPickersDay-today": {
        border: "1.5px solid #880303 !important",
      },

      "& .MuiMultiSectionDigitalClock-root": {
        borderLeft: "1px solid #f0f0f0",
      },
      "& .MuiMultiSectionDigitalClockSection-root": {
        width: "64px",
        padding: "6px 0",
        "&::after": { display: "none" },
      },
      "& .MuiMultiSectionDigitalClockSection-item": {
        fontSize: "13px",
        fontWeight: 500,
        borderRadius: "8px",
        margin: "2px 6px",
        color: "#444",
      },
      "& .MuiMultiSectionDigitalClockSection-item:hover": {
        backgroundColor: "rgba(136,3,3,0.08)",
      },
      "& .MuiMultiSectionDigitalClockSection-item.Mui-selected": {
        backgroundColor: "#880303 !important",
        color: "#fff !important",
        fontWeight: 700,
      },

      "& .MuiClock-pin, & .MuiClockPointer-root": {
        backgroundColor: "#880303",
      },
      "& .MuiClockPointer-thumb": {
        border: "16px solid #880303",
      },
      "& .MuiClockNumber-root.Mui-selected": {
        backgroundColor: "#880303",
      },

      "& .MuiDialogActions-root, & .MuiPickersLayout-actionBar": {
        borderTop: "1px solid #f0f0f0",
        padding: "10px 16px",
      },
      "& .MuiDialogActions-root .MuiButton-root, & .MuiPickersLayout-actionBar .MuiButton-root":
        {
          textTransform: "none",
          fontWeight: 600,
          fontSize: "13px",
          borderRadius: "8px",
          color: "#880303",
        },
    },
    modifiers: [
      {
        name: "flip",
        enabled: true,
        options: { boundary: "viewport", padding: 8 },
      },
      {
        name: "preventOverflow",
        enabled: true,
        options: { boundary: "viewport", padding: 8, altAxis: true },
      },
    ],
  },
};

function Announcement() {
  const BASE_URL = process.env.REACT_APP_BASEURL;
  const [filterText, setFilterText] = useState("");
  const [buttonText, setButtonText] = useState();
  const [formTitle, setFormTitle] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [imageMessage, setImageMessage] = useState("");
  const [imagePreview, setImagePreview] = useState(false);
  const [announcementId, setannouncementId] = useState();
  const [StartDate, setStartDate] = useState(null);
  const [EndDate, setEndDate] = useState(null);

  const {
    announcementResult,
    loading,
    announcementError,
    announcementMessage,
    buttonLoading,
    deleteButtonLoading,
    announcementFormModal,
  } = useSelector((state) => state.announcement);

  const datePickerRef1 = useRef(null);
  const datePickerRef2 = useRef(null);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAnnouncement());
  }, []);

  const [announcementForm, setAnnouncementForm] = useState({
    Title: "",
    Description: "",
    StartDate: "",
    EndDate: "",
  });

  useEffect(() => {
    reset(announcementForm);
  }, [announcementForm]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: announcementForm,
  });

  useEffect(() => {
    const image = new Image();
    image.src = imageUrl;
  }, [imageUrl]);

  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const fileToBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof callback === "function") {
        callback(reader.result);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleImageChange = (e) => {
    const uploadImage = e.target.files[0];
    const fileType = uploadImage.type;
    if (["image/png", "image/jpg", "image/jpeg"].includes(fileType)) {
      if (uploadImage) {
        const image = new Image();
        const imageTypeRegex = /^image\/(jpeg|jpg|png)$/;
        const maxSizeInBytes = 2048 * 2048;

        image.onload = () => {
          if (
            uploadImage.type.match(imageTypeRegex) &&
            uploadImage.size <= maxSizeInBytes
          ) {
            setImageMessage("");
            setImageUrl(URL.createObjectURL(e.target.files[0]));
            setImagePreview(true);
          } else {
            setImageUrl("");
            setImagePreview(false);
            setImageMessage("Invalid image format!");
          }
        };
        image.src = URL.createObjectURL(uploadImage);
      }
    } else {
      setImageUrl("");
      setImagePreview(false);
      setImageMessage("Invalid image format!");
    }
  };

  const onSubmit = (data) => {
    if (!imageMessage) {
      const payload = {
        Title: data.Title,
        Description: data.Description,
        StartDate: StartDate
          ? moment(StartDate).tz(DISPLAY_TIMEZONE).format("YYYY-MM-DD HH:mm:ss")
          : null,
        EndDate: EndDate
          ? moment(EndDate).tz(DISPLAY_TIMEZONE).format("YYYY-MM-DD HH:mm:ss")
          : null,
      };
      fileToBase64(data.AnnouncementLogoURL[0], (base64) => {
        payload.AnnouncementLogoURL = base64;
        dispatch(addAnnouncement(payload));
      });
    }
  };

  const handleDelete = (ID, flag) => {
    setannouncementId(ID);
    dispatch(deleteAnnouncement(ID, flag));
  };

  const formatDateTime = (date) => {
    if (!date) return "-";
    return moment.utc(date).tz(DISPLAY_TIMEZONE).format(LONG_TIME_FORMAT);
  };

  const handleAddAnnouncement = () => {
    reset({
      Title: "",
      Description: "",
      AnnouncementLogoURL: "",
    });
    setImageUrl("");
    setFormTitle("Add Announcement");
    setButtonText("Submit");
    setImagePreview(false);
    setAnnouncementForm({});
    setStartDate(null);
    setEndDate(null);
    dispatch(prepareAnnouncementForm());
  };

  const closeAnnouncementModel = () => {
    dispatch(resetAnnouncement());
    setImageMessage("");
    setStartDate(null);
    setEndDate(null);
  };

  useEffect(() => {
    if (announcementError !== null && announcementError !== undefined) {
      displayAlert(announcementError, "alert-danger");
    }
    if (announcementMessage !== null && announcementMessage !== undefined) {
      displayAlert(announcementMessage, "alert-success");
    }
  }, [announcementError, announcementMessage]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
    dispatch(resetAnnouncement());
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
    dispatch(resetAnnouncement());
  };

  const columns = [
    { displayName: "#", key: "key" },
    { displayName: "TITLE", key: "Title" },
    { displayName: "DESCRIPTION", key: "Description" },
    { displayName: "START DATE", key: "StartDate" },
    { displayName: "END DATE", key: "EndDate" },
    { displayName: "SLIDE", key: "AnnouncementLogoURL" },
    { displayName: "STATUS", key: "status" },
    { displayName: "ACTION", key: "action" },
  ];

  const filteredItems =
    Array.isArray(announcementResult) && announcementResult.length > 0
      ? announcementResult.filter((item) => {
          if (typeof filterText !== "string" || typeof item !== "object")
            return false;
          return Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(filterText.toLowerCase()),
          );
        })
      : [];

  let dataSource =
    filteredItems &&
    filteredItems.length > 0 &&
    filteredItems.map((announcement, key) => {
      return {
        key: key + 1,
        Title: announcement.Title,
        Description: (
          <span
            data-toggle="tooltip"
            data-placement="top"
            title={announcement.Description}
          >
            {announcement.Description?.length > 80
              ? `${announcement.Description.substring(0, 80)}...`
              : announcement.Description || ""}
          </span>
        ),
        StartDate: formatDateTime(announcement.StartDate),
        EndDate: formatDateTime(announcement.EndDate),
        AnnouncementLogoURL: (
          <span
            data-toggle="tooltip"
            data-placement="top"
            title="View"
            onClick={() =>
              window.open(
                `${BASE_URL}/announcements/${announcement.AnnouncementLogoURL}?${Date.now()}`,
                "_blank",
              )
            }
          >
            <EyeLineIcon
              size="1.2em"
              style={{ color: "#880303", cursor: "pointer" }}
            />
          </span>
        ),
        status:
          announcement.IsActive === 1 ? (
            <span className="badge badge-success">Active</span>
          ) : (
            <span className="badge badge-danger">Inactive</span>
          ),
        action: (
          <>
            {deleteButtonLoading && announcementId == announcement.ID ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
              ></span>
            ) : announcement.IsActive === 1 ? (
              <Popconfirm
                title="Are you sure to inactive this announcement?"
                okText="Yes"
                cancelText="No"
                placement="topRight"
                onConfirm={() => handleDelete(announcement.ID, 0)}
              >
                <Link className="deleteBtn" to="# ">
                  <span
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Inactive"
                  >
                    <DeleteBin5Fill
                      size="1.2em"
                      style={{ color: "#f14336", marginRight: "3px" }}
                    />
                  </span>
                </Link>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="Are you sure to active this announcement?"
                okText="Yes"
                cancelText="No"
                placement="topRight"
                onConfirm={() => handleDelete(announcement.ID, 1)}
              >
                <Link className="deleteBtn" to="# ">
                  <span
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Active"
                  >
                    <CheckboxCircleFill
                      size="1.2em"
                      style={{ color: "#2cb549", marginRight: "3px" }}
                    />
                  </span>
                </Link>
              </Popconfirm>
            )}
          </>
        ),
      };
    });

  return (
    <CardLayout title="Announcement">
      {showAlert && (
        <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
      )}
      <div className="row">
        <div className="col-lg-6 col-md-6 od-2">
          <SearchBar onFilter={handleFilterChange} filterText={filterText} />
        </div>
        <div className="col-lg-6 col-md-6 text-right">
          <SideButtons
            title="Add Announcement"
            buttonStyle="primary"
            onClick={handleAddAnnouncement}
          />
        </div>
      </div>
      <Table
        columns={columns}
        loading={loading}
        data={dataSource}
        pagination={true}
      />

      {/* Add Announcement */}
      <Modal
        showModal={announcementFormModal}
        title={formTitle}
        onHide={closeAnnouncementModel}
        width={550}
        showFooter={false}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="col-md-12 mb-1">
            <label>Title</label>
            <input
              type="text"
              placeholder="Title Name"
              className="form-control"
              name="Title"
              {...register("Title", {
                required: true,
              })}
            />
            {errors.Title?.type === "required" && (
              <div className="invalid-feedback">Title name is required !</div>
            )}
          </div>

          <div className="col-md-12 mb-1">
            <label>Description</label>
            <textarea
              className="form-control"
              name="Description"
              rows="4"
              {...register("Description", {
                required: true,
              })}
            />
            {errors.Description?.type === "required" && (
              <div className="invalid-feedback">Description is required !</div>
            )}
          </div>

          {/* Start / End Date - redesigned */}
          <div className="row mx-0">
            {/* Start Date */}
            <div className="col-md-6 mb-3">
              <label
                className="d-flex align-items-center mb-1"
                style={{ fontWeight: 500, color: "#444" }}
              >
                Start Date
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  ref={datePickerRef1}
                  timezone={DISPLAY_TIMEZONE}
                  value={
                    StartDate ? dayjs(StartDate).tz(DISPLAY_TIMEZONE) : null
                  }
                  onChange={(newValue) =>
                    setStartDate(newValue ? newValue.toISOString() : null)
                  }
                  minDateTime={dayjs().tz(DISPLAY_TIMEZONE)}
                  format={PICKER_FORMAT}
                  views={["year", "month", "day", "hours", "minutes"]}
                  ampm
                  timeSteps={{ hours: 1, minutes: 1 }}
                  slotProps={{
                    ...datePickerSlotProps,
                    digitalClockSectionItem: { sx: { minHeight: "34px" } },
                  }}
                />
              </LocalizationProvider>
            </div>

            {/* End Date */}
            <div className="col-md-6 mb-3">
              <label
                className="d-flex align-items-center mb-1"
                style={{ fontWeight: 500, color: "#444" }}
              >
                End Date
              </label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  ref={datePickerRef2}
                  timezone={DISPLAY_TIMEZONE}
                  value={EndDate ? dayjs(EndDate).tz(DISPLAY_TIMEZONE) : null}
                  onChange={(newValue) =>
                    setEndDate(newValue ? newValue.toISOString() : null)
                  }
                  minDateTime={
                    StartDate
                      ? dayjs(StartDate).tz(DISPLAY_TIMEZONE)
                      : dayjs().tz(DISPLAY_TIMEZONE)
                  }
                  format={PICKER_FORMAT}
                  views={["year", "month", "day", "hours", "minutes"]}
                  ampm
                  timeSteps={{ hours: 1, minutes: 1 }}
                  slotProps={{
                    ...datePickerSlotProps,
                    digitalClockSectionItem: { sx: { minHeight: "34px" } },
                  }}
                />
              </LocalizationProvider>
            </div>
          </div>

          <div className="col-md-12 mb-1 d-flex flex-column ">
            <label>Slide </label>
            <input
              type="file"
              name="AnnouncementLogoURL"
              {...register("AnnouncementLogoURL", {
                required: true,
              })}
              className="form-control"
              onChange={handleImageChange}
            />
            {
              <small style={{ opacity: "0.7", color: "red" }}>
                Note - The image size should be less than 2 Mb. The acceptable
                file extensions are png,jpg,jpeg !
              </small>
            }

            {errors.AnnouncementLogoURL?.type === "validate" && (
              <div className="invalid-feedback">
                {errors.AnnouncementLogoURL.message}
              </div>
            )}

            {imageMessage && (
              <div className="invalid-feedback">{imageMessage}</div>
            )}
            {!imageUrl &&
              !imageMessage &&
              errors.AnnouncementLogoURL?.type === "required" && (
                <div className="invalid-feedback">Slide is required !</div>
              )}

            {imagePreview && (
              <img
                src={
                  imageUrl == ""
                    ? `${BASE_URL}//networks/${announcementForm.AnnouncementLogoURL}`
                    : imageUrl
                }
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  // maxHeight:"300px",
                  margin: "10px 0 0 0",
                  objectFit: "contain",
                }}
              />
            )}
          </div>

          <div className="text-right row my-2">
            <div className="col-md-12">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={closeAnnouncementModel}
              >
                Close
              </button>
              <Button
                loading={buttonLoading}
                title={buttonText}
                buttonClass="btn btn-primary"
                buttonType="submit"
              />
            </div>
          </div>
        </form>
      </Modal>
    </CardLayout>
  );
}

export default Announcement;
